
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'VacanciesBecomePartTeamBlock',
  computed: {
    localValues: function () {
      return this.externalData?.VacanciesBecomePartTeamBlock || this.values || {};
    },
    buttonLink: function () {
      return this.localValues?.button_link || ""
    }
  },
});
